export default __webpack_public_path__ + "static/media/homepage_module_real-participation.7d56e319.png";